import { Component } from '@theme/component';
class MokshBundle extends Component {
  #controller;
  #tier = 2;
  #buttonLabel;
  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    const options = { signal: this.#controller.signal };
    const addButton = this.querySelector('[data-bundle-add]');
    this.#buttonLabel ||= addButton.textContent;
    window.addEventListener('pageshow', () => {
      addButton.disabled = false;
      addButton.textContent = this.#buttonLabel;
      this.#refresh();
    }, options);
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-bundle-tier]');
      if (!button) return;
      this.#tier = Number(button.dataset.bundleTier);
      this.querySelectorAll('[data-bundle-tier]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      this.querySelectorAll('[data-bundle-slot]').forEach((slot, index) => {
        slot.hidden = index >= this.#tier;
        slot.querySelectorAll('select,input').forEach(input => input.disabled = slot.hidden);
      });
      this.#refresh();
    }, options);
    this.addEventListener('change', () => this.#refresh(), options);
    this.querySelector('form').addEventListener('submit', event => this.#submit(event), options);
    this.#refresh();
  }
  disconnectedCallback() { super.disconnectedCallback(); this.#controller?.abort(); }
  #money(value) { return new Intl.NumberFormat(this.dataset.locale || 'en-IN', { style:'currency', currency:this.dataset.currency || 'INR' }).format(value / 100); }
  #refresh() {
    let subtotal = 0, complete = true;
    this.querySelectorAll('[data-bundle-product]').forEach(select => {
      const option = select.selectedOptions[0], preview = select.closest('[data-bundle-slot]').querySelector('[data-bundle-preview]');
      if (option?.value && option.dataset.image) {
        if (preview.dataset.variant !== option.value) {
          const image = document.createElement('img'); image.src = option.dataset.image; image.width=480; image.height=480; image.loading='lazy'; image.alt=option.dataset.title; preview.replaceChildren(image); preview.dataset.variant=option.value;
        }
      } else { preview.replaceChildren(); delete preview.dataset.variant; }
      if (select.disabled) return;
      if (!option?.value) complete = false;
      else subtotal += Number(option.dataset.price);
    });
    const discount = Math.round(subtotal * (this.#tier === 3 ? 20 : 10) / 100);
    this.querySelector('[data-bundle-subtotal]').textContent = complete ? this.#money(subtotal) : '-';
    this.querySelector('[data-bundle-saving]').textContent = complete ? this.#money(discount) : '-';
    this.querySelector('[data-bundle-total]').textContent = complete ? this.#money(subtotal-discount) : '-';
  }
  async #submit(event) {
    event.preventDefault();
    const button = this.querySelector('[data-bundle-add]'), error = this.querySelector('[data-bundle-error]');
    if (button.disabled || !event.target.reportValidity()) return;
    const quantities = new Map();
    for (const select of this.querySelectorAll('[data-bundle-product]:not(:disabled)')) quantities.set(select.value, (quantities.get(select.value)||0)+1);
    const original = button.textContent;
    button.disabled = true; button.textContent = this.dataset.adding; error.hidden = true;
    try {
      const root = this.dataset.root || '/';
      const response = await fetch(root+'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[...quantities].map(([id,quantity])=>({id,quantity}))})});
      if (!response.ok) throw new Error('Unable to add bundle');
      window.location.assign(root+'cart');
    } catch {
      error.textContent = this.dataset.error; error.hidden = false;
      button.disabled = false; button.textContent = original;
    }
  }
}
if (!customElements.get('moksh-bundle')) customElements.define('moksh-bundle', MokshBundle);
